import { AuditUtils, IAuditField } from "../PA.Core/Basic/AuditUtils";
import { esWB_Policy_Cube, esWB_Policy_Cube_Process, esWB_Policy_Procedure, esWB_SalesArea } from "../PA.Core/PAdbSchema";
import { AuditService } from "../PA.Core/Security/AuditService";
import { PolicyBO } from "./PolicyBO";


export class PolicyBOAudit {

    //Audit Log Service for Policy


    static async PolicyBOAudit(PolicyBO: PolicyBO) : Promise<PolicyBOAudit> {

        const self = PolicyBO;
        const auditService: AuditService = new AuditService(self.dbContext)
        auditService.setReference("Policy", self.drWB_Policy.cif.WB_POLICY_ID)

        //@ts-ignore
        self.deleteKeys = self.deleteKeys || {}
        //@ts-ignore
        let deleteKeys: any = self.deleteKeys

        //Main policy
        const policyParams: IAuditField[] = [
            {fieldName: "POLICY_ID", realName: "ID", bAllMsg: true},
            {fieldName: "POLICY_NAME", realName: "Name", bAllMsg: true},
            {fieldName: "COMMENTS", realName: "Comments"},
            {fieldName: "EFFECTIVE_START_DT", realName: "Effective Start Date", bAllMsg: true},
            {fieldName: "EFFECTIVE_END_DT", realName: "Effective End Date", bAllMsg: true},
        ]

        //Policy cube relations
        const cubeRelParam: IAuditField[] = [
            {fieldName: "WB_POLICYCUBE_ID",
            realName: "Cube",
            fkMapper: esWB_Policy_Cube,
            fkMapperNameField: "CUBE_NAME",
            fkMapperIdField: "CUBE_ID",
            bAllMsg: true}
        ]

        //Policy cube procedure items
        const cubeProcedureParams: IAuditField[] = [
            {fieldName: "WB_POLICYPLR_ID",
            realName: "Policy Procedure",
            fkMapper: esWB_Policy_Procedure,
            fkMapperNameField: "LINE_NAME",
            fkMapperIdField: "LINE_ID",
            bAllMsg: true}
        ]

        //Policy sales area relations
        const salesAreaParams: IAuditField[] = [
            {fieldName: "WB_SALESAREA_ID",
            realName: "Sales Area",
            fkMapper: esWB_SalesArea,
            fkMapperNameField: "SALES_AREA_NAME",
            fkMapperIdField: "SALES_AREA_ID",
            bAllMsg: true}
        ]

        //Main object logging
        await  AuditUtils.logRecord(auditService, self.drWB_Policy, policyParams, {
            objectName: 'Policy',
            deletedKeys: deleteKeys
        })

        for (let policyCubeRow of self.drWB_Policy.WB_PolicyCubeRows) {
            await AuditUtils.logRecord(auditService, policyCubeRow, cubeRelParam, {
                objectName: 'Cube',
                deletedKeys: deleteKeys
            })
        }

        for (let policyCubeProcedureRow of self.drWB_Policy.WB_PolicyProcedureRows) {
            await AuditUtils.logRecord(auditService, policyCubeProcedureRow, cubeProcedureParams, {
                objectName: 'Procedure',
                deletedKeys: deleteKeys
            })
        }

        for (let aSalesArea of self.drWB_Policy.WB_PolicySalesAreaRows) {
            await AuditUtils.logRecord(auditService, aSalesArea, salesAreaParams, {
                objectName: 'Sales Area',
                deletedKeys: deleteKeys
            })

        }
        return auditService;
    }


}
